import { MenuItemToAddModel } from "./menu-item-to-add.model";

export class SubcategoryToAddModel {
  public id: string;
  public visible: boolean;
  public menuItems: Array<MenuItemToAddModel>;
}
